module.exports = __webpack_public_path__ + "img/icon_shoppingbag.dab3e3ed.svg";